module.exports = __webpack_public_path__ + "static/fipcpurplefloralrab4-1f53544a623e9e6eb3b34533ed63a8b2.jpeg";